import axiosInstance from "../../utils/axiosInstance";

// loading
import {
  setService,
  setServices,
  setLoadingTrue,
  setLoadingFalse,
} from "../../store/slices/service";
import { setMessage } from "../../store/slices/message";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";

export const get_services = async (dispatch: AppDispatch, page: number = 1) => {
  dispatch(setLoadingTrue());
  try {
    const response = await axiosInstance.get(`v1/get-services?page=${page}`);

    const { data } = response.data;
    dispatch(setServices(data));
  } catch (err) {
    // logger action
  }
  dispatch(setLoadingFalse());
};

export const get_service = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoadingTrue());
  try {
    const response = await axiosInstance.get(`v1/get-service/${id}`);

    const { data } = response.data;
    dispatch(setService(data));
  } catch (err) {
    // logger action
  }
  dispatch(setLoadingFalse());
};

export const request_service = async (dispatch: AppDispatch, formData: any) => {
  dispatch(setLoadingTrue());
  try {
    const response = await axiosInstance.post("v1/request-services", formData);

    const { message } = response.data;
    dispatch(setMessage({ type: "success", message: message }));
    dispatch(setLoadingFalse());
    return true;
  } catch (err) {
    if (isAxiosError(err)) {
      const { message } = err?.response?.data;
      dispatch(setMessage({ type: "error", message }));
    }
    dispatch(setLoadingFalse());
    return false;
  }
};

export const advert_services = async (dispatch: AppDispatch) => {
  dispatch(setLoadingTrue());
  try {
    const response = await axiosInstance.get("/get-advert-services");

    const { data } = response.data;
    dispatch(setServices(data));
  } catch (err) {
    if (isAxiosError(err)) {
      const { message } = err?.response?.data;
      console.log(message);
      dispatch(setMessage({ type: "error", message }));
    }
  }
  dispatch(setLoadingFalse());
};
